// extracted by mini-css-extract-plugin
export default {"coachContainer":"CoachesTab_coachContainer__81tGo","closeIcon":"CoachesTab_closeIcon__3nwui"};